import { App, Button, Tooltip } from "antd";
import useActionDialogRefine from "hook/bailiff/dialog/useActionDialog";
import moment from "moment";
import React from "react";

import { HiOutlineArrowUturnRight } from "react-icons/hi2";
import { useDispatch } from "react-redux";
import { setBailiffDialogKick } from "store/bailiff/bailiff/dialog/bailiff_dialog.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ButtonNext5s = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  const { second, duration } = useActionDialogRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleNext5s = () => {
    if (second + 5 > duration) return message.error("Đã đến giới hạn cuối");
    const fronzen = moment().valueOf();
    const next = second + 5;
    const time = `change-${fronzen}-${next}`;
    dispatch(setBailiffDialogKick(time));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title="Tới trước 5s">
      <Button
        onClick={handleNext5s}
        type="text"
        size="large"
        icon={<HiOutlineArrowUturnRight />}
      />
    </Tooltip>
  );
};
export default ButtonNext5s;
